import { render } from "./BreedersPage.vue?vue&type=template&id=7610312e"
import script from "./BreedersPage.vue?vue&type=script&lang=js"
export * from "./BreedersPage.vue?vue&type=script&lang=js"

import "./BreedersPage.vue?vue&type=style&index=0&id=7610312e&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__